import {
  useFileCollectionFromServiceId,
  useFileCollectionsFromParentId,
} from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import { Tab } from '@/components/TabsBlock';
import LoopingEllipsis from '@/components/LoopingEllipsis';
import CollectionSelectorList, {
  CollectionSelectorListItem,
  type CollectionSelectorListItemProps,
} from '@/components/CollectionSelectorList';
import { classes } from './utils';

export type FilesTabProps = {
  isFetchingData: boolean;
  name: string;
  label: string;
  openFileIds: number[];
  onToggleFileId: CollectionSelectorListItemProps['onToggleFileId'];
  onOpenCollection: CollectionSelectorListItemProps['onOpenCollection'];
  onCloseCollection: CollectionSelectorListItemProps['onCloseCollection'];
};

export default function FilesTab({
  isFetchingData,
  name,
  label,
  openFileIds,
  onToggleFileId,
  onOpenCollection,
  onCloseCollection,
}: FilesTabProps) {
  const { activeServiceId } = useAppState();
  const parentCollection = useFileCollectionFromServiceId(activeServiceId);
  const fileCollections = useFileCollectionsFromParentId(parentCollection?.id);
  return (
    <Tab className={classes.tab} name={name} label={label}>
      {isFetchingData ? (
        <div>
          Loading scan service
          <LoopingEllipsis />
        </div>
      ) : (
        <CollectionSelectorList>
          {fileCollections.map(({ id }) => (
            <CollectionSelectorListItem
              key={id}
              fileCollectionId={id}
              openFileIds={openFileIds}
              onToggleFileId={onToggleFileId}
              onOpenCollection={onOpenCollection}
              onCloseCollection={onCloseCollection}
            />
          ))}
        </CollectionSelectorList>
      )}
    </Tab>
  );
}
